// @ts-expect-error Untyped Dependency
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import VizExAvatar from 'visitor-ui-component-library/avatar/VizExAvatar';
// @ts-expect-error Untyped Dependency
import { getSenderTypeForCMF } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getAvatar, getDisplayName } from 'conversations-message-history/senders/operators/getters';
import { mrHubBot } from 'conversations-message-history/constants/images';
import { BOT, SYSTEM } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const noop = () => {};
export default class SenderAvatar extends PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    const {
      onClick,
      sender
    } = this.props;
    onClick(sender);
  }
  render() {
    const {
      isLoading,
      sender,
      size
    } = this.props;
    if (isLoading) return /*#__PURE__*/_jsx(SkeletonCircle, {
      size: 32
    });
    if (!sender) return /*#__PURE__*/_jsx(VizExAvatar, {
      alt: "",
      size: size
    });
    const senderType = getSenderTypeForCMF(sender);
    const defaultAgentName = I18n.text('conversations-visitor-message-history.agent');
    const altText = I18n.text('conversations-visitor-message-history.avatar', {
      identifier: getDisplayName(sender) || defaultAgentName
    });
    switch (senderType) {
      case BOT:
      case SYSTEM:
        return /*#__PURE__*/_jsx(VizExAvatar, {
          size: size,
          src: getAvatar(sender) || mrHubBot,
          alt: altText
        });
      default:
        return /*#__PURE__*/_jsx("span", {
          onClick: this.handleClick,
          children: /*#__PURE__*/_jsx(VizExAvatar, {
            size: size,
            src: getAvatar(sender),
            alt: altText
          })
        });
    }
  }
}
SenderAvatar.displayName = 'SenderAvatar';
SenderAvatar.propTypes = {
  isLoading: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  sender: RecordPropType('Sender'),
  size: VizExAvatar.propTypes.size
};
SenderAvatar.defaultProps = {
  onClick: noop,
  size: 'sm'
};